import React from 'react';
import { connect } from 'react-redux';

const mapState = (state) => {
	return {
		listaDescargas: state.descargas.listaDescargas,
		timestamp: state.descargas.timestamp,
		visible: state.descargas.visible
	};
}

const mapDispatch = (dispatch) => {
	return {
		listaShow: () => {
			dispatch({ "type": "DESCARGAS_LISTA_SHOW" });
		},
		listaHide: () => {
			dispatch({ "type": "DESCARGAS_LISTA_HIDE" });
		}
	}
}

class Descargas extends React.Component {
	
	close = () => {
		this.props.listaHide();
	}
	
	componentWillMount = () => {
		//this.props.listaShow();
	}

	render() {
		return	(
			<div className="descargas" style={{"display": (this.props.visible)? "block":"none" }}>
				<div>
					<span><b>DESCARGAS</b></span>
					<span onClick={this.close} style={{"float":"right","lineHeight":"17px","cursor":"pointer"}}>
						<img style={{"height":"12px","width":"12px"}} src={ require("../img/x.svg") } />
					</span>
				</div>
				{ this.props.timestamp && this.props.listaDescargas.map((item, i) => 
                    <div key={i}>
						<span>
							<img style={{"height":"12px","width":"12px","marginRight":"3px"}} src={ require( (item.completo == 100)? "../img/icon-dowload.svg": "../img/load_mini.gif") } />
							<small>Archivo: {item.nombre}</small>
						</span>
						<span className="load-bar" style={{"width":item.completo+"%", "background": (item.error)? "#FF0000" : "#f57405" }}></span>
                    </div>
				)}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Descargas);


// WEBPACK FOOTER //
// ./src/descargas/descargas.cmpt.js